/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Card,
  IssueCardBody,
  GetCards200,
  GetCardsParams,
  ActivateCardBody,
  SuspendCardBody,
  UnsuspendCardBody,
  LockCardBody,
  UnlockCardBody,
  CancelCardBody,
  GetCardSensitiveDetails200,
  GetCardSensitiveDetailsParams,
  ChangeCardPinBody,
  PostCardsSpendingControlsBody,
  UpdateCardPhoneNumber200,
  UpdateCardPhoneNumberBody,
  VerifyCardInfo200,
  VerifyCardInfoBody
} from './schema'



/**
 * Issue a card under the respective card account.

This can be either a physical, which is a traditional tangible card made of plastic, or a virtual card, which is a digital version of a physical card that can be used for online transactions or transactions made through a mobile device.

When issuing a card, the productId must be specified and determines the card product to issue. The card product determines the card type, card face, card features, benefits, interest rates, capabilties, etc. The list of available productIds is static will be provided by your solution manager based on your pre-determined card product offering(s).
The card will be chosen from the available inventory and given out in numerical order according to its card number.

If you wish to issue a specific card, you may specify the card number suffix (up to the full card numberA) using the `cardSuffix` field. If the card number is not part of the `productId` or already issued, the request will fail.

Multiple cards can be issued under the a single card account.

Once the request has been processed:
- The card will be created in the system under the respective card account.
- The card can then be activated and used for making purchases.
 * @summary Issue Card
 */
export const issueCard = (
    issueCardBody: IssueCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards`,
      issueCardBody,options
    );
  }



    export type IssueCardMutationResult = NonNullable<Awaited<ReturnType<typeof issueCard>>>
    export type IssueCardMutationBody = IssueCardBody
    export type IssueCardMutationError = AxiosError<unknown>

    export const useIssueCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueCard>>, TError,{data: IssueCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueCard>>, {data: IssueCardBody}> = (props) => {
          const {data} = props ?? {};

          return  issueCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof issueCard>>, TError, {data: IssueCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get Cards
 * @summary Get Cards
 */
export const getCards = (
    params: GetCardsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCards200>> => {
    return axios.get(
      `/cards`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCardsQueryKey = (params: GetCardsParams,) => [`/cards`, ...(params ? [params]: [])];

    
export type GetCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getCards>>>
export type GetCardsQueryError = AxiosError<unknown>

export const useGetCards = <TData = Awaited<ReturnType<typeof getCards>>, TError = AxiosError<unknown>>(
 params: GetCardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCardsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCards>>> = ({ signal }) => getCards(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCards>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Activate a card
 * @summary Activate Card
 */
export const activateCard = (
    activateCardBody: ActivateCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/activate`,
      activateCardBody,options
    );
  }



    export type ActivateCardMutationResult = NonNullable<Awaited<ReturnType<typeof activateCard>>>
    export type ActivateCardMutationBody = ActivateCardBody
    export type ActivateCardMutationError = AxiosError<unknown>

    export const useActivateCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateCard>>, TError,{data: ActivateCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateCard>>, {data: ActivateCardBody}> = (props) => {
          const {data} = props ?? {};

          return  activateCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof activateCard>>, TError, {data: ActivateCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Suspend a card. Immediately prevents card from further transactions and can only be reactivated by operator using the unsuspend endpoint.

 * @summary Suspend Card
 */
export const suspendCard = (
    suspendCardBody: SuspendCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/suspend`,
      suspendCardBody,options
    );
  }



    export type SuspendCardMutationResult = NonNullable<Awaited<ReturnType<typeof suspendCard>>>
    export type SuspendCardMutationBody = SuspendCardBody
    export type SuspendCardMutationError = AxiosError<unknown>

    export const useSuspendCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspendCard>>, TError,{data: SuspendCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suspendCard>>, {data: SuspendCardBody}> = (props) => {
          const {data} = props ?? {};

          return  suspendCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof suspendCard>>, TError, {data: SuspendCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Unsuspend a card
 * @summary Unsuspend Card
 */
export const unsuspendCard = (
    unsuspendCardBody: UnsuspendCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/unsuspend`,
      unsuspendCardBody,options
    );
  }



    export type UnsuspendCardMutationResult = NonNullable<Awaited<ReturnType<typeof unsuspendCard>>>
    export type UnsuspendCardMutationBody = UnsuspendCardBody
    export type UnsuspendCardMutationError = AxiosError<unknown>

    export const useUnsuspendCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsuspendCard>>, TError,{data: UnsuspendCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsuspendCard>>, {data: UnsuspendCardBody}> = (props) => {
          const {data} = props ?? {};

          return  unsuspendCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof unsuspendCard>>, TError, {data: UnsuspendCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Lock a card. Immediately prevents further transactions. Card can be unlocked immediately using the unlock endpoint.

Card Lock & Unlock functionality is designed for client use.

 * @summary Lock Card
 */
export const lockCard = (
    lockCardBody: LockCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/lock`,
      lockCardBody,options
    );
  }



    export type LockCardMutationResult = NonNullable<Awaited<ReturnType<typeof lockCard>>>
    export type LockCardMutationBody = LockCardBody
    export type LockCardMutationError = AxiosError<unknown>

    export const useLockCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockCard>>, TError,{data: LockCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockCard>>, {data: LockCardBody}> = (props) => {
          const {data} = props ?? {};

          return  lockCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof lockCard>>, TError, {data: LockCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Unlock a locked card. Immediately allows subsequent card transactions upon unlocking.

Card Lock & Unlock functionality is designed for client use. For operator use, use the suspend and unsuspend endpoints.

 * @summary Unlock Card
 */
export const unlockCard = (
    unlockCardBody: UnlockCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/unlock`,
      unlockCardBody,options
    );
  }



    export type UnlockCardMutationResult = NonNullable<Awaited<ReturnType<typeof unlockCard>>>
    export type UnlockCardMutationBody = UnlockCardBody
    export type UnlockCardMutationError = AxiosError<unknown>

    export const useUnlockCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockCard>>, TError,{data: UnlockCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockCard>>, {data: UnlockCardBody}> = (props) => {
          const {data} = props ?? {};

          return  unlockCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof unlockCard>>, TError, {data: UnlockCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Request card cancellation, if the card is active, it will be deactivated immediately and no further card charges will go through.
 * @summary Cancel a card
 */
export const cancelCard = (
    cancelCardBody: CancelCardBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/cancel`,
      cancelCardBody,options
    );
  }



    export type CancelCardMutationResult = NonNullable<Awaited<ReturnType<typeof cancelCard>>>
    export type CancelCardMutationBody = CancelCardBody
    export type CancelCardMutationError = AxiosError<unknown>

    export const useCancelCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCard>>, TError,{data: CancelCardBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelCard>>, {data: CancelCardBody}> = (props) => {
          const {data} = props ?? {};

          return  cancelCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof cancelCard>>, TError, {data: CancelCardBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * @summary Get Card Sensitive Info
 */
export const getCardSensitiveDetails = (
    params: GetCardSensitiveDetailsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardSensitiveDetails200>> => {
    return axios.get(
      `/cards/card-sensitive-info`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCardSensitiveDetailsQueryKey = (params: GetCardSensitiveDetailsParams,) => [`/cards/card-sensitive-info`, ...(params ? [params]: [])];

    
export type GetCardSensitiveDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getCardSensitiveDetails>>>
export type GetCardSensitiveDetailsQueryError = AxiosError<unknown>

export const useGetCardSensitiveDetails = <TData = Awaited<ReturnType<typeof getCardSensitiveDetails>>, TError = AxiosError<unknown>>(
 params: GetCardSensitiveDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCardSensitiveDetails>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCardSensitiveDetailsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardSensitiveDetails>>> = ({ signal }) => getCardSensitiveDetails(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCardSensitiveDetails>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Change Card ATM PIN for a card. Card ATM pin is used for ATM withdrawals and is effective immediately.
 */
export const changeCardPin = (
    changeCardPinBody: ChangeCardPinBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/cards/change-pin`,
      changeCardPinBody,options
    );
  }



    export type ChangeCardPinMutationResult = NonNullable<Awaited<ReturnType<typeof changeCardPin>>>
    export type ChangeCardPinMutationBody = ChangeCardPinBody
    export type ChangeCardPinMutationError = AxiosError<unknown>

    export const useChangeCardPin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCardPin>>, TError,{data: ChangeCardPinBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeCardPin>>, {data: ChangeCardPinBody}> = (props) => {
          const {data} = props ?? {};

          return  changeCardPin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof changeCardPin>>, TError, {data: ChangeCardPinBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * By setting a value for these fields, the cardholder can ensure that their card spending is limited to a specified amount each day.

If either limit is not desired, it can be disabled by setting the value to null.

 * @summary Control Spending
 */
export const postCardsSpendingControls = (
    postCardsSpendingControlsBody: PostCardsSpendingControlsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Card>> => {
    return axios.post(
      `/cards/spending-controls`,
      postCardsSpendingControlsBody,options
    );
  }



    export type PostCardsSpendingControlsMutationResult = NonNullable<Awaited<ReturnType<typeof postCardsSpendingControls>>>
    export type PostCardsSpendingControlsMutationBody = PostCardsSpendingControlsBody
    export type PostCardsSpendingControlsMutationError = AxiosError<unknown>

    export const usePostCardsSpendingControls = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCardsSpendingControls>>, TError,{data: PostCardsSpendingControlsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCardsSpendingControls>>, {data: PostCardsSpendingControlsBody}> = (props) => {
          const {data} = props ?? {};

          return  postCardsSpendingControls(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postCardsSpendingControls>>, TError, {data: PostCardsSpendingControlsBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Update the phone number for a card.
 */
export const updateCardPhoneNumber = (
    updateCardPhoneNumberBody: UpdateCardPhoneNumberBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateCardPhoneNumber200>> => {
    return axios.post(
      `/cards/update-phone`,
      updateCardPhoneNumberBody,options
    );
  }



    export type UpdateCardPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof updateCardPhoneNumber>>>
    export type UpdateCardPhoneNumberMutationBody = UpdateCardPhoneNumberBody
    export type UpdateCardPhoneNumberMutationError = AxiosError<unknown>

    export const useUpdateCardPhoneNumber = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCardPhoneNumber>>, TError,{data: UpdateCardPhoneNumberBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCardPhoneNumber>>, {data: UpdateCardPhoneNumberBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCardPhoneNumber(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateCardPhoneNumber>>, TError, {data: UpdateCardPhoneNumberBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Validate a card with it's product id, last 6 digits, expiry date.
 * @summary Validate a card with card info.
 */
export const verifyCardInfo = (
    verifyCardInfoBody: VerifyCardInfoBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<VerifyCardInfo200>> => {
    return axios.post(
      `/cards/validate-card-info`,
      verifyCardInfoBody,options
    );
  }



    export type VerifyCardInfoMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCardInfo>>>
    export type VerifyCardInfoMutationBody = VerifyCardInfoBody
    export type VerifyCardInfoMutationError = AxiosError<unknown>

    export const useVerifyCardInfo = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCardInfo>>, TError,{data: VerifyCardInfoBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCardInfo>>, {data: VerifyCardInfoBody}> = (props) => {
          const {data} = props ?? {};

          return  verifyCardInfo(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof verifyCardInfo>>, TError, {data: VerifyCardInfoBody}, TContext>(mutationFn, mutationOptions)
    }
    